<template>
  <div class="lesson-page py-4">
    <div class="row">
      <div v-if="loading" class="col-12 text-center py-5">
        <span>Loading...</span>
      </div>

      <div v-else-if="!lesson" class="col-12 text-center py-5">
        <span>Course Details not found.</span>
      </div>

      <div v-else class="col-12 col-md-8 offset-md-2">
        <VideoPlayer :isVideo="isVideo" :videoLessonId="lesson.id" :videoUrl="lesson.videoUrl" :title="lesson.title"
          :description="lesson.description" :shortDescription="shortenedDescription"
          :showFullDescription="showFullDescription" :thumbnail="lesson.thumbnail" :level="course.level"
          :category="course.speciality.title" :duration="lesson.duration" :visible="true" :modalMode="'inline'"
          :courseId="lesson.courseId" :progress="progress" :previousWatchedTime="previousWatchedTime || 0"
          @progress-updated="onProgressUpdated" @close="() => { }" @next-click="goToNext" @previous-click="goToPrevious"
          @toggle-description="toggleDescription" :hasNextLesson="hasNextLesson"
          :hasPreviousLesson="hasPreviousLesson" />
      </div>
    </div>
  </div>
</template>


<script>
import VideoPlayer from '@/components/TrainingCourses/VideoPlayer.vue';
import axios from 'axios';
import { eventBus } from "@/main";

export default {
  name: 'LessonDetail',
  components: { VideoPlayer },
  data() {
    return {
      lesson: {
        id: null,
        title: '',
        description: '',
        videoUrl: '',
        thumbnail: '',
        duration: 0,
        courseId: null,
        isVideo: false,
      },
      course: null,
      previousLesson: null,
      nextLesson: null,
      hasNextLesson: false,
      hasPreviousLesson: false,
      loading: true,
      showFullDescription: false,
      progress: 0,
      previousWatchedTime: 0,
    };
  },
  computed: {
    isVideo() {
      return !/youtu\.?be/.test(this.lesson.videoUrl);
    },
    shortenedDescription() {
      if (!this.lesson.description) return '';
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.lesson.description;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';
      if (this.showFullDescription || plainText.length <= 300) return this.lesson.description;
      return plainText.slice(0, 300) + '...';
    },
    isDescriptionLong() {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.lesson.description;
      const plainText = tempDiv.textContent || tempDiv.innerText || '';
      return plainText.length > 300;
    }
  },
  methods: {
    async fetchLessonAndList() {
      this.loading = true;
      const lessonId = this.$route.params.lessonId;
      try {
        const { data } = await axios.get(`/training-courses/video-lessons/${lessonId}`);

        this.lesson = {
          id: data.id,
          title: data.title,
          description: data.description,
          isVideo: !data.isFromYoutube,
          videoUrl: data.isFromYoutube ? data.videoPath : data.videoPath,
          thumbnail: data.thumbnailPath,
          duration: data.duration,
          courseId: data.course.id,
        };
        this.previousWatchedTime = data.learningProgress ? data.learningProgress.watchTime : 0,
        this.progress = data.learningProgress ? data.learningProgress.progressPercent : 0;
        this.course = data.course;

        if (data.previousLesson) {
          this.hasPreviousLesson = true;
          this.previousLesson = {
            id: data.previousLesson.id,
            title: data.previousLesson.title,
            order: data.previousLesson.order,
          };
        }

        if (data.nextLesson) {
          this.hasNextLesson = true;
          this.nextLesson = {
            id: data.nextLesson.id,
            title: data.nextLesson.title,
            order: data.nextLesson.order,
          };
        }

        eventBus.$emit('changeTop', {
          title: this.lesson.title,
          simple: true,
          topLogo: false
        });
      } catch (e) {
        console.error('Failed to fetch lesson', e);
      } finally {
        this.loading = false;
      }
    },
    goToPrevious() {
      if (this.previousLesson) {
        this.$router.push({ name: 'staff.training-courses.video-lesson', params: { lessonId: this.previousLesson.id } });
      }
    },
    goToNext() {
      if (this.nextLesson) {
        this.$router.push({ name: 'staff.training-courses.video-lesson', params: { lessonId: this.nextLesson.id } });
      }
    },
    toggleDescription() {
      this.showFullDescription = !this.showFullDescription;
    },
    onProgressUpdated({ courseId, status, watchTime, progressPercent }) {
      // console.log('Progress updated:', watchTime, status, progressPercent);
      this.progress = progressPercent;
      this.previousWatchedTime = watchTime;
    },
  },
  watch: {
    '$route.params.lessonId': {
      immediate: true,
      async handler() {
        await this.fetchLessonAndList();
        this.showFullDescription = false;
      },
    },
  },
  // async mounted() {
  //   await this.fetchLessonAndList();
  // },
};
</script>